<template>
    <v-container class="fill-height wrap d-flex align-center" :class="{ 'pa-1': $vuetify.breakpoint.xs }">

        <v-carousel v-if="!$vuetify.breakpoint.mobile" height="800" cycle class="rounded-xl"
                    :value="buyPanel && buyPanel.token_id"
                    :prev-icon="mdiChevronLeft"
                    :next-icon="mdiChevronRight">
            <v-carousel-item
                             height="800"
                             transition="fade-transition"
                             v-for="item in photos"
                             :key="item._id"
                             :src="item.url">
                <template>
                    <div class="d-flex align-center fill-height">
                        <v-img max-height="70%" :src="item.url" contain></v-img>
                    </div>
                </template>
            </v-carousel-item>
        </v-carousel>
        <!-- <pre>{{ JSON.stringify(buyPanel, null, 2) }}</pre> -->
        <v-btn text small @click="dialog.signup = true">Commission a BraNFT™</v-btn>
            <sup>
                <router-link :to="{ name: 'faq', query: { category: 'collector', id: '6240f1138da87400011d613b' }}" class="text-caption" style="text-decoration: none">(What?)</router-link>
            </sup>
        <ts-nft-buy-panel v-model="buyPanel"></ts-nft-buy-panel>
        <v-dialog v-model="dialog.signup" :content-class="$vuetify.breakpoint.mobile ? 'mobile' : ''" :width="$vuetify.breakpoint.mobile ? '100%' : 640">
            <bnft-request-user-card @close="closeRequestUserCard" ref="bnft-request-user-card"></bnft-request-user-card>
        </v-dialog>
    </v-container>
</template>
<style scoped>
</style>
<style>
.v-dialog.mobile {
    margin: 0 !important;
}
div.v-window.rounded-xl.v-item-group.v-carousel
    > div.v-window__container
    > div.v-window-item
    > div
    > div.v-responsive__content {
    backdrop-filter: blur(50px);
}
</style>
<script>
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import TsNftBuyPanel from "../components/TsNftBuyPanel.vue";
import BnftRequestUserCard from "../components/BnftRequestUserCard.vue";

export default {
    name: "Gallery",
    components: {
        TsNftBuyPanel,
        BnftRequestUserCard,
    },
    data() {
        return {
            fadeOut: false,
            photos: null,
            buyPanel: null,
            mdiChevronLeft,
            mdiChevronRight,
            dialog: {
                signup: this.$route.query.transactionHashes || this.$route.query.state || this.$route.query.commission ? true : false,
            },
        };
    },
    methods: {
        closeRequestUserCard() {
            this.$router
                .replace({ "query.transactionHashes": undefined })
                .catch(() => {});
        },
    },
    mounted() {
        if (this.$store.state.commissionState && this.$store.state.commissionState.params) {
            this.$near.commission(this.$store.state.commissionState.params, true);
        }
    },
    computed: {},
    watch: {
        isLoading() {
            const self = this;
            if (!self.isLoading)
                self.$nextTick(() => {
                    setTimeout(function () {}, 1000);
                });
        },
        buyPanel(buyPanel) {
            this.$set(
                this,
                "photos",
                buyPanel && buyPanel.photos && buyPanel.photos.length
                    ? buyPanel.photos
                    : []
            );
        },
    },
};
</script>
